import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { map, switchMap } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import * as AppStoreSelectors from '../../root-store/app-store/selectors';
import { mapToAccountInformationModel } from '../functions';
import { IAccountInformationModel } from '../models';
import { IUserItemApi } from '../models/api';

@Injectable({
	providedIn: 'root'
})
export class UserService {

	private http = inject(HttpClient)
	private store = inject(Store)

	getMe(): Observable<IAccountInformationModel> {
		return this.store.select(AppStoreSelectors.selectConfig).pipe(
			switchMap(config => this.http.get<IUserItemApi>(`${config.apiUrl}/api/Accounts/me`)),
			map(model => mapToAccountInformationModel(model))
		);
	}

	updateUserLanguage(language: string) {
		const headers = new HttpHeaders().append('Content-Type', 'application/json');
		return this.store.select(AppStoreSelectors.selectConfig).pipe(
			switchMap(config => this.http.post<void>(`${config.apiUrl}/api/Accounts/language`, JSON.stringify(language), {headers}))
		);
	}
}
